import React,{ useEffect, useState } from "react";
//import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper"; 
import { MdRunningWithErrors } from "react-icons/md";
const WithdrawalRequest = ()=>{
    const [withdrawalRequest, setWithdrawalRequest] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [showModal, setShowModal] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [showModalRetry, setShowModalRetry] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
  

    const handleApprovedClick = (id, approved) => {
      setSelectedRow({ id, approved });
      setShowModal(true);
    };
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`withdrawalRequest?page=${page}`);
            setWithdrawalRequest(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    // const del = async (id) =>{
    //     if(window.confirm("Are you sure you want to delete this record?")){
    //         await axios.delete(`withdrawalRequest/${id}`);
    //         setWithdrawalRequest(withdrawalRequest.filter((withdrawalRequest) => withdrawalRequest.id !== id));
    //     }
    // }

    const handleApprove = async () => {
        if (!selectedRow) return;
    
        try {
            const response = await axios.put(`withdrawalRequest/${selectedRow.id}`, {
                approved: 1,
            });
    
            if (response.status === 200 || response.status === 204) {
                alert("Status updated successfully.");
                closeModal();
            } else {
                alert("Failed to update status.");
            }
        } catch (error) {
            console.error("Error updating status:", error);
            alert("An error occurred.");
        }
    };
    

    const closeModal = () => {
        setShowModal(false);
        setShowModalRetry(false);
        setSelectedRow(null);
    };

   
    const handleOpenModal = (id) => {
        setSelectedId(id);
        setShowModalRetry(true);
    };
  
    const confirmRetry = async () => {
      //onRetry(selectedId);
      console.log("Retrying transaction with ID:", selectedId);
      try {
        const response = await axios.put(`withdrawalRetry/${selectedId}`, {
            transaction: 1,
        });

        if (response.status === 200 || response.status === 204) {
           // alert("Status updated successfully.");
            closeModal();
        } else {
            alert("Failed to update status.");
        }
    } catch (error) {
        console.error("Error updating status:", error);
        alert("An error occurred.");
    }

      setShowModalRetry(false);
    };
    return (
        <Wrapper pageTitle={'Withdrawal Requests'}>
            <InnerNav createLink={'/withdrawalRequestCreate'} listLink={'/withdrawalRequest'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Time</th>
                                    <th className="px-4 py-3">Msisdn </th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th className="px-4 py-3">Charges </th>
                                    <th className="px-4 py-3">Net Payout</th>
                                    <th className="px-4 py-3">SourceIp </th>
                                    <th className="px-4 py-3">TransactionId </th>
                                    <th className="px-4 py-3">Approved </th>
                                    <th className="px-4 py-3">Sent To</th>
                                    <th className="px-4 py-3">ApiResponse </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {withdrawalRequest.map((withdrawalRequest)=>{
                                         return(
                                             <tr  key={withdrawalRequest.id}
                                             className={`text-gray-700 dark:text-gray-400 ${
                                               withdrawalRequest.approved === 1 && withdrawalRequest.TransactionID !== ""
                                                 ? "bg-green-100 dark:bg-green-900"
                                                 : withdrawalRequest.approved === 1
                                                 ? "bg-blue-100 dark:bg-blue-900"
                                                 : withdrawalRequest.ResultCode === 1 && withdrawalRequest.approved === 1 
                                                 ? "bg-red-100 dark:bg-red-900"
                                                 : ""
                                             }`}>
                                                 <td className="px-4 py-5">{withdrawalRequest.id}</td>
                                                 <td className="px-4 py-3 text-sm">{withdrawalRequest.time_in}</td>
                                                 <td className="px-4 py-3 text-sm">{withdrawalRequest.Msisdn}</td>
                                                 <td className="px-4 py-3 text-sm">{withdrawalRequest.Amount}</td>
                                                 <td className="px-4 py-3 text-sm">{withdrawalRequest.charges}</td>
                                                 <td className="px-4 py-3 text-sm">{withdrawalRequest.net_payout}</td>
                                                 <td className="px-4 py-3 text-sm">{withdrawalRequest.SourceIp}</td>
                                                 <td className="px-4 py-3 text-sm">{withdrawalRequest.TransactionID}</td>
                                                 <td className="px-4 py-3 text-sm" onClick={() => handleApprovedClick(withdrawalRequest.id, withdrawalRequest.approved)} >{withdrawalRequest.approved}</td>
                                                 <td className="px-4 py-3 text-sm">{withdrawalRequest.ReceiverPartyPublicName}</td>
                                                 <td className={`px-4 py-3 text-sm ${
                                               withdrawalRequest.ResultCode === 1
                                                 ? "bg-red-100 dark:bg-red-900"
                                                 : ""
                                             }`}>{withdrawalRequest.api_response} {withdrawalRequest.ResultDesc}
                                            
                                             </td>
                                             <td>
                                             { withdrawalRequest.ResultCode === 1 
                                             ? <button><MdRunningWithErrors className="text-3xl font-bold text-red-900 " onClick={() => handleOpenModal(withdrawalRequest.id)} title="Retry this Transaction"/>   </button>
                                            :""
                                            }
                                             </td>
                                                 
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                        {showModal && selectedRow && (
                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                                <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md">
                                    <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-4">Approval Details</h2>
                                    <p className="text-gray-800 dark:text-gray-200 mb-2">
                                        ID: <strong>{selectedRow.id}</strong>
                                    </p>
                                    <p className="text-gray-800 dark:text-gray-200 mb-4">
                                        Approved: <strong>{selectedRow.approved}</strong>
                                    </p>

                                    {selectedRow.approved === 0 && (
                                        <p className="mb-4">
                                            <button
                                                onClick={handleApprove}
                                                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                                            >
                                                Approve
                                            </button>
                                        </p>
                                    )}

                                    <div className="text-right">
                                        <button
                                            onClick={closeModal}
                                            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Modal */}
                        {showModalRetry && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
                                <h2 className="text-lg font-semibold mb-4">Confirm Retry</h2>
                                <p className="mb-6">Do you really want to retry the transaction?</p>
                                <div className="flex justify-end gap-3">
                                <button
                                    onClick={() => setShowModalRetry(false)}
                                    className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={confirmRetry}
                                    className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                                >
                                    Yes, Retry
                                </button>
                                </div>
                            </div>
                            </div>
                        )}

                        
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default WithdrawalRequest;